import { createUseStyles } from 'react-jss';

const styles = createUseStyles(theme => {
  const { breakpoints, palette, spacing } = theme;
  return {
    homeContainer: {
      backgroundColor: palette.background.main,
      minHeight: '1250px',
    },
    bodyContainer: {
      marginTop: `${spacing['5']}px`,
      maxWidth: '1400px',
      margin: 'auto',
      [`@media screen and (min-width: ${breakpoints.md}px)`]: {
        marginTop: `${spacing['7']}px`,
      },
    },
    mobileSearchBox: {
      visibility: 'hidden',
      height: 0,
      margin: 0,
      [`@media screen and (max-width: ${breakpoints.sm}px)`]: {
        height: 'auto',
        visibility: 'visible',
        margin: `${spacing['4']}px`,
      },
    },

    tabletSearchBox: {
      visibility: 'hidden',
      [`@media screen and (min-width: ${breakpoints.sm}px)`]: {
        visibility: 'visible',
      },
      [`@media screen and (min-width: ${breakpoints.md}px)`]: {
        width: '70%',
      },
      [`@media screen and (min-width: ${breakpoints.lg}px)`]: {
        width: '50%',
      },
    },
    featuredApps: {
      [`@media screen and (max-width: 1383px) and (min-width: 1133px)`]: {
        '& .appCardSelector:nth-child(n+4)': {
          display: 'none',
        },
      },
    },
    results: {
      '& button': {
        height: 'auto',
      },
    },
    fullWidth: {
      width: '100%',
    },
  };
});

export default styles;
